"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */

/**
 *  A DID provider proxy, DID provider interface that acts as rpc client, to
 *  relay request to iframe (rpc server)
 */
var DidProviderProxy = /*#__PURE__*/function () {
  function DidProviderProxy(provider, accountId) {
    (0, _classCallCheck2["default"])(this, DidProviderProxy);
    (0, _defineProperty2["default"])(this, "accountId", void 0);
    (0, _defineProperty2["default"])(this, "provider", void 0);
    this.provider = provider;
    this.accountId = accountId;
  }

  (0, _createClass2["default"])(DidProviderProxy, [{
    key: "send",
    value: function () {
      var _send = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(msg, origin) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                msg.params = Object.assign({}, msg.params, {
                  accountId: this.accountId
                });
                _context.next = 3;
                return this.provider.send(msg, origin);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "isDidProvider",
    get: function get() {
      return true;
    }
  }]);
  return DidProviderProxy;
}();

var _default = DidProviderProxy;
exports["default"] = _default;